import { AlertProps } from '@chakra-ui/react';

export const betRecoveryAlertProps: AlertProps = {
  color: 'alpha.500',
};
